/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_DateInputs */

const vi_einvoice_draft_date = /** @type {(inputs: Einvoice_Draft_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày hóa đơn`)
};

/**

* @param {Einvoice_Draft_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_date = /** @type {((inputs?: Einvoice_Draft_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_date(inputs)
});